
import React, { useState } from "react";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card"; 
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "./DataTable";

const Customers = () => {
  const [rows, setRows] = useState([]);
  const [totalEntries, setTotalEntries] = useState(0);
  const [page, setPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(8);
  const [loading, setLoading] = useState(false);
  
  const handleEntriesChange = (newEntries) => {
    setEntriesPerPage(newEntries);
    setPage(1); 
  };

  const columns = [
    { Header: "Domain", accessor: "website", align: "left" },
    { Header: "No of Queries", accessor: "total_queries", align: "left" },
    { Header: "Source", accessor: "source", align: "left" },
    { Header: "Registered on", accessor: "registered_on", align: "left" },
  ];
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ width: "100%", marginTop: "0px" }}>
        
        <Card>
          <SoftBox p={3} lineHeight={1.2}>
            {loading ? (
              <p style={{ textAlign: "center" }}>Loading data...</p>
            ) : (
              <>
                <div style={{ width: "100%" }}>
                  <DataTable
                    table={{ columns, rows }}
                    entriesPerPage={{
                      defaultValue: entriesPerPage,
                      entries: [5, 10, 15],
                    }}
                    canSearch
                    date
                    csv
                    showTotalEntries
                    onEntriesChange={handleEntriesChange}
                    totalPages={Math.ceil(totalEntries / entriesPerPage)}
                  />
                </div>
              </>
            )}
          </SoftBox>
        </Card>
      </div>
    </DashboardLayout>
  );
};
export default Customers;
